import { schema } from "normalizr";

export const bankSchema = new schema.Entity("bank", {});
export const arrayOfBankSchemas = new schema.Array(bankSchema);
